import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { markCampaignThreadRead } from '../redux/buzzbridge/actions';
import type { WorkspacePerspective } from '../redux/buzzbridge/campaignWorkspace.types';

/** PATCH mark-read once when a campaign thread workspace is opened. */
export function useCampaignThreadMarkReadOnOpen({
    participantId,
    campaignId,
    perspective,
    enabled,
}: {
    participantId: string;
    campaignId?: string;
    perspective: WorkspacePerspective;
    enabled: boolean;
}) {
    const dispatch = useDispatch();
    const markedForRef = useRef<string | null>(null);

    useEffect(() => {
        const pid = participantId?.trim();
        if (!enabled || !pid) return;
        if (markedForRef.current === pid) return;
        markedForRef.current = pid;

        dispatch(
            markCampaignThreadRead({
                participantId: pid,
                campaignId,
                refetchCampaign: perspective === 'brand' && Boolean(campaignId),
                refetchProfile: perspective === 'creator',
            }),
        );
    }, [dispatch, participantId, campaignId, perspective, enabled]);
}
